import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { type ReactNode, useState } from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip'

const DisplayTooltipOnHover = ({
  children,
  text,
  asChild = false,
  tooltipClassName,
  tooltipStyle,
}: {
  text: string
  children: ReactNode
  asChild?: boolean
  tooltipClassName?: string
  tooltipStyle?: React.CSSProperties
}) => {
  const [open, setOpen] = useState(false)

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          asChild={asChild}
          onClick={() => setOpen(false)}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {children}
        </TooltipTrigger>
        <TooltipPrimitive.Portal>
          <TooltipContent className={tooltipClassName} style={tooltipStyle}>
            <div>{text}</div>
          </TooltipContent>
        </TooltipPrimitive.Portal>
      </Tooltip>
    </TooltipProvider>
  )
}

export default DisplayTooltipOnHover
